import {svgIconWrapper} from '../svg-icon-wrapper';

import SquareCheckRegular from './square-check-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <SquareCheckRegular {...props} />;
}

SvgComponent.iconName = 'squareCheckRegular';

export const SquareCheckRegularIcon = svgIconWrapper(SvgComponent);
